export default "__VITE_ASSET__9355cb02__"